import React from "react";
import { Button, Modal, ModalFooter } from "@telluscompany/design-system";
import { useLocalization } from "@i18n";
import { LoadingBlurDiv } from "@shared/components";
import { formatGeneralDisplayValue } from "../../utils/formatGeneralDisplayValue";
import { FieldItem } from "../GeneralDashboardFieldGrid";
import { GeneralDashboardModalDetailField } from "../GeneralDashboardModalFields";

interface GeneralReadOnlyFieldsModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  fields: FieldItem[];
  isLoading?: boolean;
  isError?: boolean;
}

export const GeneralReadOnlyFieldsModal: React.FC<GeneralReadOnlyFieldsModalProps> = ({
  open,
  onClose,
  title,
  fields,
  isLoading = false,
  isError = false,
}) => {
  const { translate } = useLocalization();
  const fallback = translate("admin.complexes.details.notProvided");

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      content={
        <LoadingBlurDiv isLoading={isLoading}>
          <div className="general-dashboard-modal-body general-dashboard-modal-body--narrow">
            {isError && (
              <p className="text-sm text-red-600">
                {translate("general.dashboard.loadError")}
              </p>
            )}
            <div className="general-dashboard-modal-field-grid">
              {fields.map((field, index) => (
                <GeneralDashboardModalDetailField
                  key={`${field.labelKey}-${index}`}
                  label={translate(field.labelKey)}
                  value={formatGeneralDisplayValue(field.value, field.isDate)}
                  fallback={fallback}
                />
              ))}
            </div>
          </div>
          <ModalFooter
            footer={
              <Button type="button" variant="primary" onClick={onClose}>
                {translate("general.dashboard.button.close")}
              </Button>
            }
          />
        </LoadingBlurDiv>
      }
    />
  );
};
